import LegalDoc from "@/components/LegalDoc";
import { KVKK_TEXT } from "@/data/legal/kvkk";

export default function KvkkPage() {
  return <LegalDoc testid="kvkk-page" title="KVKK Aydınlatma Metni" text={KVKK_TEXT} />;
}
